import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type LightboxDialogProps = {
    open: boolean
    image: string | null
    onClose: () => void
}

const LightboxDialog = (props: LightboxDialogProps) => {
    const { open, image, onClose } = props;
    
    if (!open || !image) return null

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            style={{ margin: 0 }}
        >
            <DialogTitle>
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={onClose}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent style={{ padding: 0 }}>
                <img
                    src={image}
                    alt="Full size"
                    style={{
                        width: '100%',
                        height: 'auto',
                    }}
                />
            </DialogContent>
        </Dialog>
    )
}

export default LightboxDialog
